// Selectors ==========================================================================================================================================================================
let myTrgBtnSearch = document.querySelector(".my-tgr-btn-search");
let myInputSearch = document.querySelector(".my-input-search");
let myResultFrame = document.querySelector(".my-result-frame");
let myNoResultFrame = document.querySelector(".my-no-result-frame");
let myResultCode = document.querySelector(".my-result-code");
let idResult = document.getElementById("idResult");
let myCollapseBtnResult = document.querySelector(".my-collapse-btn-result");
// let myCloseBtnResult = document.querySelector(".my-close-btn-result");
let myCloseBtnNoResult = document.querySelector(".my-close-btn-no-result");
let loaderWrapper = document.querySelector(".loader-wrapper");
let myErrorMsg = document.querySelector(".my-error-msg");

// Expand/collapse result
myCollapseBtnResult.addEventListener('click', () => {
    myCollapseBtnResult.classList.toggle('fa-circle-plus')
    myResultCode.classList.toggle('d-none')
});

// Close result frames
myCloseBtnNoResult.addEventListener('click', () => {
    myNoResultFrame.classList.add('d-none');
});
// myCloseBtnResult.addEventListener('click', () => {
//     myResultFrame.classList.add('d-none');
// });

// Read data =========================================================================================================================================================================

// Read provider ------------------------------------------------------------------------------
myTrgBtnSearch.addEventListener('click', (e) => {
    // Prevent submit of form
    e.preventDefault();
    // Reset no/result-frame
    myResultFrame.classList.add('d-none');
    myNoResultFrame.classList.add('d-none');
    // Reset result collapser
    myCollapseBtnResult.classList.remove('fa-circle-plus');
    myResultCode.classList.remove('d-none');
    // Read input value
    let inputValue = myInputSearch.value;

    if(inputValue.length != 0) {
        // Hide error msg
        myErrorMsg.classList.add("d-none");
        // Show loader
        loaderWrapper.classList.remove('d-none');
        // Call readProviderAPI function
        readProviderAPI(inputValue);
    } else {
        // Show error msg
        myErrorMsg.classList.remove("d-none");
    }
});

// Read API ----------------------------------------------------------------------------
async function readProviderAPI(inputValue) {
    let response = await fetch(`${process.env.SELFHELP_API}/providers/${inputValue}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    })

    if (response.status != 400 && response.status != 403 && response.status != 404 && response.status != 500 && response.status != 502) {
        let responseParsed = await response.json();

        console.log("API response - Success:");
        console.log(responseParsed);

        parseData(responseParsed);
    } else {
        let responseParsed = await response.json();

        console.log("API response - Error:");
        console.log(responseParsed);

        // Hide loader
        loaderWrapper.classList.add('d-none');
        // Show no result-frame
        myNoResultFrame.querySelector("span").innerHTML = responseParsed.message;
        myNoResultFrame.classList.remove('d-none');
    }
};

// Render data read -------------------------------------------------------------------------
function parseData(responseParsed) {

    // Hide loader
    loaderWrapper.classList.add('d-none');

    if (responseParsed.detail.length > 0) {    
        // Reset idResult
        idResult.innerHTML = "";

        idResult.innerHTML += 
        `<div class="input-group input-group-sm mb-3">
            <span class="input-group-text">Providers</span>
        </div>`;

        var providerNumber = 0;
        responseParsed.detail.forEach (provider => {
            let responseArrayFormat = Object.entries(provider); // SUPER USEFUL. Creates an array from object, like: [[UID, 1], [IsActive, false] ...].
        
            // Provider number
            providerNumber++;
            idResult.innerHTML += 
            `<div class="input-group input-group-sm mb-3">
                <span class="input-group-text">${providerNumber}</span>
                <input type="text" class="form-control" readonly value="Provider" name="${providerNumber}">
            </div>`;        

            // Render data
            responseArrayFormat.forEach (item => {
                if (item[0] == "clinics") {
                    let clinicArrayFormat = Object.entries(item[1]);

                    idResult.innerHTML += 
                    `<div class="input-group input-group-sm mb-3">
                        <span class="input-group-text">Clinics</span>
                    </div>`;

                    clinicArrayFormat.forEach (clinic => {
                        console.log(clinic);

                        // treatment number
                        var clinicNumber = Number(clinic[0]) + 1;
                        idResult.innerHTML += 
                        `<div class="input-group input-group-sm mb-3">
                            <span class="input-group-text">${clinicNumber}</span>
                            <input type="text" class="form-control" readonly value="Clinic" name="${clinicNumber}">
                        </div>`;        

                        // treatment details
                        idResult.innerHTML += 
                        `<div class="input-group input-group-sm mb-3">
                            <span class="input-group-text">Clinic ID</span>
                            <input type="text" class="form-control" readonly value="${clinic[1]['ClinicID']}" name="ID">
                        </div>`;        

                        idResult.innerHTML += 
                        `<div class="input-group input-group-sm mb-3">
                            <span class="input-group-text">Clinic Name</span>
                            <input type="text" class="form-control" readonly value="${clinic[1]['ClinicName']}" name="ClinicName">
                        </div>`;        
                    });                    
                } else {
                    idResult.innerHTML += 
                    `<div class="input-group input-group-sm mb-3">
                        <span class="input-group-text">${item[0]}</span>
                        <input type="text" class="form-control" readonly value="${item[1]}" name="${item[0]}">
                    </div>`;
                }
            });
        });

        // Show result
        myResultFrame.classList.remove('d-none');
    } else {
        // Show NO result
        myNoResultFrame.classList.remove('d-none');
    }
}